const variables = require('../../../variables/Variables.js');
const apiUrl = variables.apiUrl;

export const giftingVideoId = '618e973be6b3540f685a1eeb'

function getStaticUrlAsync(id) {
    const fetchUrl = apiUrl + 'asset/url?id=' + id;
    return new Promise((resolve, reject) => {
        fetch(fetchUrl)
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw new Error('Fetch static asset url failed with code ' + response.status);
                }
            })
            .then(responseJson => resolve(responseJson))
            .catch(error => reject(error));
    });
}

export const NavMarkerSpriteName = Object.freeze({
    NORMALLEFT: 'NavMarkerNormalLeft',
    NORMALRIGHT: 'NavMarkerNormalRight',
    NORMALUP: 'NavMarkerNormalUp',
    NORMALDOWN: 'NavMarkerNormalDown',
    NORMALUPLEFT: 'NavMarkerNormalUpLeft',
    NORMALDOWNLEFT: 'NavMarkerNormalDownLeft',
    NORMALUPRIGHT: 'NavMarkerNormalUpRight',
    NORMALDOWNRIGHT: 'NavMarkerNormalDownRight',
    NORMALSTAIRSUP: 'NavMarkerNormalStairsUp',
    NORMALSTAIRSDOWN: 'NavMarkerNormalStairsDown',
    HOVERLEFT: 'NavMarkerHoverLeft',
    HOVERRIGHT: 'NavMarkerHoverRight',
    HOVERUP: 'NavMarkerHoverUp',
    HOVERDOWN: 'NavMarkerHoverDown',
    HOVERUPLEFT: 'NavMarkerHoverUpLeft',
    HOVERDOWNLEFT: 'NavMarkerHoverDownLeft',
    HOVERUPRIGHT: 'NavMarkerHoverUpRight',
    HOVERDOWNRIGHT: 'NavMarkerHoverDownRight',
    HOVERSTAIRSUP: 'NavMarkerHoverStairsUp',
    HOVERSTAIRSDOWN: 'NavMarkerHoverStairsDown',
    FADELEFT: 'NavMarkerFadeLeft',
    FADERIGHT: 'NavMarkerFadeRight',
    FADEUP: 'NavMarkerFadeUp',
    FADEDOWN: 'NavMarkerFadeDown',
    FADEUPLEFT: 'NavMarkerFadeUpLeft',
    FADEDOWNLEFT: 'NavMarkerFadeDownLeft',
    FADEUPRIGHT: 'NavMarkerFadeUpRight',
    FADEDOWNRIGHT: 'NavMarkerFadeDownRight',
    FADESTAIRSUP: 'NavMarkerFadeStairsUp',
    FADESTAIRSDOWN: 'NavMarkerFadeStairsDown'
});

export function getHeartFillUrlAsync() {
    return getStaticUrlAsync('HeartFill');
}

export function getHeartEmptyUrlAsync() {
    return getStaticUrlAsync('HeartEmpty');
}

export function getNavMarkerUrlAsync(spriteName) {
    return getStaticUrlAsync(spriteName);
}

export function getProductMarkerNormalAsync() {
    return getStaticUrlAsync('ProductMarkerNormal');
}

export function getProductMarkerHoverAsync() {
    return getStaticUrlAsync('ProductMarkerHover');
}

export function getVideoMarkerNormalAsync() {
    return getStaticUrlAsync('VideoMarkerNormal');
}

export function getModalCloseIconNormalAsync() {
    return getStaticUrlAsync('ModalCloseIconNormal');
}

export function getModalCloseIconHoverAsync() {
    return getStaticUrlAsync('ModalCloseIconHover');
}

export function getDragToSpinAsync() {
    return getStaticUrlAsync('DragToSpin');
}

export function getDragToSpinIconAsync() {
    return getStaticUrlAsync('DragToSpinIcon');
}

export function getFacebookAsync() {
    return getStaticUrlAsync('FacebookIcon');
}

export function getTwitterAsync() {
    return getStaticUrlAsync('TwitterIcon');
}

export function getVideoPlayAsync() {
    return getStaticUrlAsync('VideoPlay');
}

export function getObsessLogoAsync() {
    return getStaticUrlAsync('ObsessLogo');
}

export function getObsessUrlAsync() {
    return getStaticUrlAsync('ObsessUrl');
}

export function getWelcomeExploreUrlAsync() {
    return getStaticUrlAsync('WelcomeExplore');
}

export function getZoomIconUrlAsync() {
    return getStaticUrlAsync('ZoomIcon');
}

export function getDirectoryMenu() {
    let menuList = [
        {
            name: 'WOMAN',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: 'Bags & Accessories Level 1',
                    sceneId: ''
                },
                {
                    name: 'Bags & Accessories Level 2',
                    sceneId: ''
                },
                {
                    name: 'Ready-to-wear',
                    sceneId: ''
                },
                {
                    name: 'Shoes',
                    sceneId: ''
                },
                {
                    name: 'Fitting Room',
                    sceneId: ''
                }
            ]
        },
        {
            name: 'MAN',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: 'Bags & Accessories',
                    sceneId: ''
                },
                {
                    name: 'Ready-to-wear',
                    sceneId: ''
                },
                {
                    name: 'Shoes',
                    sceneId: ''
                },
                {
                    name: 'Fitting Room',
                    sceneId: ''
                }
            ]
        },
        {
            name: 'SPHERE',
            sceneId: '',
            isHeader: true,
            haveItems: false,
        },
        {
            name: 'LOUNGE',
            sceneId: '',
            isHeader: true,
            haveItems: false,
        },
        {
            name: '57<sup>th</sup> STREET WINDOWS',
            sceneId: '',
            isHeader: true,
            haveItems: false,
        }
    ]

    return menuList;
}

export function getFloorMenu() {
    let menuData = [
        {
            name: 'LEVEL 1',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: '1',
                    imageUrl: "https://cdn.obsess-vr.com/fendi/fendi-level1-map.svg",
                    pins: [
                        {
                            name: '', // Women's Shoes
                            sceneId: '',
                            x: '105',
                            y: '55'
                        },
                        {
                            name: '', // Women's Bag's & Accessories
                            sceneId: '',
                            x: '160',
                            y: '215'
                        }
                    ]
                }
            ]
        },
        {
            name: 'LEVEL 2',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: '1',
                    imageUrl: "https://cdn.obsess-vr.com/fendi/fendi-level2-map.svg",
                    pins: [
                        {
                            name: '', // Men's Shoes
                            sceneId: '',
                            x: '253',
                            y: '150'
                        },
                        {
                            name: '', // Men's Ready to Wear
                            sceneId: '',
                            x: '212',
                            y: '169'
                        },
                        {
                            name: '', // Lounge
                            sceneId: '',
                            x: '156',
                            y: '168'
                        },
                        {
                            name: '', // Women's Ready to Wear
                            sceneId: '',
                            x: '86',
                            y: '166'
                        },
                        {
                            name: '', // Sphere
                            sceneId: '',
                            x: '19',
                            y: '154'
                        },
                        {
                            name: '', // Men's Bag's & Accessories
                            sceneId: '',
                            x: '175',
                            y: '118'
                        },
                        {
                            name: '', // Women's Bags & Accessories
                            sceneId: '',
                            x: '98',
                            y: '130'
                        }
                    ]
                }
            ]
        }
    ];

    return menuData;
}

export function getCurrentSceneName() {
    const url = window.location.hash;
    const currentSceneName = url.split("/")[1];
    return currentSceneName;
}